import { render, staticRenderFns } from "./ComexPedidoFormularios.vue?vue&type=template&id=e2e289a4"
import script from "./ComexPedidoFormularios.vue?vue&type=script&lang=js"
export * from "./ComexPedidoFormularios.vue?vue&type=script&lang=js"
import style0 from "./ComexPedidoFormularios.vue?vue&type=style&index=0&id=e2e289a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports